import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Minister } from '../../models/minister.model';
import { GeneralService } from '@asambleas-services/general/general.service';

@Injectable()
export class MinisterService {

    constructor(private httpClient: HttpClient,
        private generalService: GeneralService) { }

    getMinisters() {
        const token = localStorage.getItem('id_token');
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        };

        return this.httpClient.get(environment.apiEndPoint + '/ministros', { headers });
    }

    resolveRequest(ministerId: number, state: string, level: string) {

        let body = {
            'minister_id': ministerId,
            'state': state,
            'level': level
        };

        const token = localStorage.getItem('id_token');
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Authorization': token
        };

        return this.httpClient.post(environment.apiEndPoint + '/ministros/aprobar-solicitud', body, { headers });
    }

    postulate(minister: Minister, files: any) {

        let body = {
            'academic_trainings': minister.academic_trainings,
            'ministerial_trainings': minister.ministerial_trainings,
            'children': minister.children
        }

        delete minister.academic_trainings;
        delete minister.ministerial_trainings;
        delete minister.children;

        body['minister'] = minister;

        const data = new FormData();

        data.append('academic_trainings', JSON.stringify(body.academic_trainings));
        data.append('ministerial_trainings', JSON.stringify(body.ministerial_trainings));
        data.append('children', JSON.stringify(body.children));
        data.append('minister', JSON.stringify(body['minister']));

        data.append('rutFile', files.rut);
        data.append('cedulaFile', files.cedula);
        data.append('registroMatrimonioFile', files.registroMatrimonio);
        data.append('credencialFile', files.credencial);

        const token = localStorage.getItem('id_token');
        const headers = {
            'Accept': 'application/json',
            'Authorization': token
        };

        console.log(data);

        return this.httpClient.post(environment.apiEndPoint + '/ministros', data, { headers });

    }

    getMinisterByUserId(userId: number = null) {

        let id = null;

        if (!userId) {
            id = (JSON.parse(localStorage.getItem('user'))).id;
        }
        else {
            id = userId;
        }

        let token = localStorage.getItem('id_token');
        let headers = new HttpHeaders({
            'Authorization': token
        });

        return this.httpClient.get(environment.apiEndPoint + '/ministros/get-by-user/' + id, { headers });

    }

    updateMinister(id: number, minister: Minister) {
        return this.httpClient.put(environment.apiEndPoint + `/ministros/${id}`, minister, this.generalService.getHeadersUser());
    }

    getFilesMinisterPostulation(idMinister: number) {
        let token = localStorage.getItem('id_token');
        let headers = new HttpHeaders({
            'Authorization': token
        });

        return this.httpClient.get(environment.apiEndPoint + '/ministros/get-files-postulation/' + idMinister, { headers });
    }

    requestCredentialRenovation(data) {
        return this.httpClient.post(environment.apiEndPoint + '/ministros/solicitar-renovacion-credencial', data, this.generalService.getHeadersUser());
    }

    statusRequestCredentialRenovation(data) {

        return this.httpClient.post(environment.apiEndPoint + '/ministros/estado-renovacion-credencial', data, this.generalService.getHeadersUser());
    }

    getRenovationCredentialRequests() {
        return this.httpClient.get(environment.apiEndPoint + '/ministros/solicitudes-renovacion-credencial', this.generalService.getHeadersUser());
    }

    setCredentialRequestStatus(id: number, data) {
        return this.httpClient.put(environment.apiEndPoint + '/ministros/set-estado/' + id, data, this.generalService.getHeadersUser());
    }

}



// WEBPACK FOOTER //
// ./src/app/services/minister/minister.service.ts